// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legal-entities-tab-content {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.tab-content-item {\n    margin-right:0;\n    width: 48%;\n}\n\n.tab-content-item-consent-text {\n    width: 100%;\n}\n\n.tab-content-item-consent-text textarea {\n    color: #000;\n}\n\n.employee-show-tab-content {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.employee-show-item {\n    margin-right:20px;\n    margin-bottom:20px;\n    width: 30%;\n}\n\n.toolbar-wrapper {\n    width: 100%;\n}", ""]);
// Exports
module.exports = exports;
